<template>
  <div class="main-con el-main">

  </div>
</template>

<script>
  export default {
    name: "SubmenuPage",
    computed: {
      menuData() {
        return this.$store.state.menuData
      }
    },
    beforeMount() {
      const currentTopMenu = this.$route.path.split('/').pop()
      const firstSubmenu = this.menuData.filter(item=>item.link == '/' + currentTopMenu)[0]||{}
      const firstSubmenuLink = (firstSubmenu.submenus||[])[0].link || ''
      if( firstSubmenuLink ) {
        this.$router.push({
          path: this.$route.path + firstSubmenuLink
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/SubmenuPage.vue